
export default {
  props: {
    header: {
      default: 'Frequently Asked <strong>Questions</strong>',
      type: String,
    },
    dark: {
      default: 'true',
      type: String,
    },
  },
  data() {
      return {
        answers: [],
        ready:false
      }
    },
    head() {
      if(this.ready && this.faqs.length === this.questions.length){
        return {
            script: [{ type: 'application/ld+json', json: this.structuredData }]
        }
      }
    },
  computed: {
    // FOR SCHEMA
    slot() {
      // const answers = []
      console.log(this.$refs.mySlot.textContent)
      const faqs =  this.$refs.mySlot.textContent.replace(/\n/g,'').split('   ')
      if (faqs[0] === ''){
        faqs.shift()
      }

      return faqs
    },
    questions() {
      const questions = []
      this.slot.forEach((qOrA) => {
        if (qOrA.includes(" Q. ")){
          const question = qOrA.replace(' Q. ','')
          questions.push(question)
        }
        else{
          this.answers.push(qOrA)
        }
      })
      return questions
    },
    faqs() {
      const faqList = []
      this.questions.forEach((question, index) => {
        faqList.push({
          "@type": "Question",
          "name": question,
          "acceptedAnswer": {
            "@type":"Answer",
            "text": this.answers[index]
          }
        })
      })

      return faqList
    },
    structuredData() {
      return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": this.faqs
      }
    }
  },
    mounted() {
      this.ready = true
    },
    render() {
    const slot = this.$slots.default
    console.log('slot', slot)
    //  return slot.text.replace(/,/g, "")
    return slot
  },


}
